import React, { useState } from 'react'
import './Header.css'
import { Link } from 'react-router-dom'
import {nav} from '../../data/Data'

const Header = () => {
  const [navlist, setnavlist] = useState(false)
  // const [showToggle, setShowToggle] = useState(true);

  // const toggleNavList = () => {
  //   setNavlist(!navlist);
  //   setShowToggle(false); // Hide the toggle after click
  // };

  return (
    <>
      <header>
        <div className="container flex">
            <div className="logo">
                {/* <img src="./images/logo.png" alt="" /> */}
            </div>
            <div className="nav">
              <ul className={navlist ? 'small' : 'flex'}>
                {nav.map((list, index) => (
                  <li key={index}>
                    <Link to={list.path}>{list.text}</Link>
                  </li>
                ))}
              </ul>
            </div>
            
            <div className="buttons">
              <Link to={"https://wa.me/c/27646122609"}><i className="fa fa-shopping-cart"></i> Order </Link>
              {/* <a href="https://wa.me/c/27646122609" className='btn order'><i className="fa fa-shopping-cart"></i> Order </a> */}
            </div>
            
            <div className="toggle">
              <button onClick={() => setnavlist(!navlist)}>
                {navlist ? <i className="fa fa-times"></i> : <i className="fa fa-bars"></i>}
              </button>
            </div>
        </div>
      </header>
    </>
    
  )
}

export default Header